export const viewPreferencesEndpoints = {
  viewPreferences: "/user-management/user-preference",
  deleteAll: "/user-management/user-preference",
} as const;
